import { object as yupObject, string as yupString, number as yupNumber } from 'yup';
import merge from 'lodash/merge';

import { validateBaseSchema } from '../../shared/gridEdit/validators';
import { userRolesDictionary } from '../../shared/authorization/userRoles';

const checkEntityForDuplicate = (
  role,
  allRoles
) => {
  const duplicates = allRoles.filter(entity => (
    entity.roleId !== role.roleId
    && (
      entity.roleName === role.roleName
      || userRolesDictionary[entity.roleName] === role.roleName
    )
  ));

  if (duplicates.length) {
    return {
      roleName: ['Role name must be unique'],
    };
  }

  return {};
};

export const roleSchemaShape = {
  roleId: yupNumber().nullable(),
  roleName: yupString().required('Role name is required'),
  description: yupString().nullable(),
  clientId: yupNumber().nullable(),
};

export const roleSchema = yupObject().shape(roleSchemaShape);


export const validateRole = (row, context, data) => {
  const baseSchemaError = validateBaseSchema(roleSchema, row, null);
  const duplicateError = checkEntityForDuplicate(row, data);

  return {
    errors: merge({}, baseSchemaError, duplicateError),
  };
};
